import AreaEffectView from "@/tabletop/effects/AreaEffectView.tsx";
import {useAreaEffect} from "@/encounter/effect/AreaEffectHooks.ts";
import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {effectsOnLevel} from "./AreaEffectLevel.ts";

export default function AreaEffectLayer() {
    const {effects} = useAreaEffect()
    const {combatants} = useCombatants();
    const {dungeonSettings} = useDungeon();
    return (<>
        {effectsOnLevel(effects, combatants, dungeonSettings.levelId).map(effect =>
            <AreaEffectView key={effect.id} effect={effect}/>)}
    </>)
}
